module.exports = __webpack_public_path__ + "img/woocommerce-placeholder.88859f81.png";